/* WESN - Microblade flash sale: the countdown in the product-page box. The end time comes from the box's data-flash-ends
   attribute (Theme settings > Microblade flash sale). When it passes, <html> gets .flash-over and the box hides itself. */
(function () {
  'use strict';
  var boxes = document.querySelectorAll('.flash-callout[data-flash-ends]');
  if (!boxes.length) return;
  var end = new Date(boxes[0].getAttribute('data-flash-ends'));
  var overText = boxes[0].getAttribute('data-flash-over') || 'Ended';
  if (isNaN(end.getTime())) return;
  var over = false;
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function tick() {
    var diff = end.getTime() - Date.now();
    var els = document.querySelectorAll('[data-flash-countdown]');
    if (diff <= 0) {
      if (!over) {
        over = true;
        document.documentElement.classList.add('flash-over');
        for (var i = 0; i < els.length; i++) els[i].textContent = overText;
      }
      return;
    }
    var d = Math.floor(diff / 864e5), h = Math.floor(diff % 864e5 / 36e5), m = Math.floor(diff % 36e5 / 6e4), s = Math.floor(diff % 6e4 / 1e3);
    var text = (d > 0 ? d + 'd ' : '') + pad(h) + 'h ' + pad(m) + 'm ' + pad(s) + 's';
    for (var k = 0; k < els.length; k++) if (els[k].textContent !== text) els[k].textContent = text;
  }
  tick();
  setInterval(tick, 1000);
})();
